import { Trans,useTranslation } from "react-i18next";

import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  DialogTitle,
  Dialog,
} from "@mui/material";

const languages = {
  cn: { code: "cn", name: "中国人", url: "/img/lang/cn.svg" },
  es: { code: "es", name: "España", url: "/img/lang/es.svg" },
  fr: { code: "fr", name: "Français", url: "/img/lang/fr.svg" },
  en: { code: "en", name: "English", url: "/img/lang/en.svg" },
};

export default function LanguageModal({ onClose, open }) {
  const { t, i18n } = useTranslation();

  const handleClose = () => {
    onClose();
  };

  const handleListItemClick = (language) => {
    i18n.changeLanguage(language.code);
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle><Trans t={t}>Change language</Trans></DialogTitle>
      <List sx={{ pt: 0 }}>
        {Object.values(languages).map((language) => (
          <ListItem key={language.code} disableGutters>
            <ListItemButton
              onClick={() => handleListItemClick(language)}
              key={language.code}
            >
              <ListItemAvatar>
                <Avatar>
                  <img src={language.url} width={24} />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={language.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}
